// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

const S = {
  Container: styled.div`
    display: flex;
    position: relative;
  `,
  Tab: styled.div<{ isShown: boolean }>`
    height: 32px;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font: 16px Noto Sans TC;
    font-weight: ${props => props.isShown ? 700 : 300};
    color: ${props => props.isShown ? '#EF8200' : '#C9C9C9'};
    padding-bottom: 3px;
    cursor: pointer;
  `,
  TabLine: styled.div`
    position: absolute;
    left: 0;
    bottom: 0;
    height: 3px;
    background-color: #EF8200;
    transition: 0.3s;
  `,
}

export { S as default }
